<script>
  import axios from 'axios'
  import { useActiveElement, useMagicKeys, whenever } from '@vueuse/core'
  import { logicAnd } from '@vueuse/math'
  import { computed } from 'vue'

  export default {
    mounted() {
      // CSRF support for Axios
      // Use safe navigation because test envs don't have a CSRF token by default
      let token = document.getElementsByName('csrf-token')[0]?.getAttribute('content')
      axios.defaults.headers.common['X-CSRF-Token'] = token
      axios.defaults.headers.common['Accept'] = 'application/json'
    },

    setup() {
      const activeElement = useActiveElement()
      const { ctrl_s } = useMagicKeys()

      const form = computed(() => activeElement.value?.closest('form'))
      const isFormFocused = computed(() => form.value != null)
      const canSubmit = logicAnd(ctrl_s, isFormFocused)

      // Ctrl+S to submit the current form — only for POST forms, not GET search forms.
      // Use dispatchEvent instead of form.submit() so Vue's v-on:submit handlers fire.
      whenever(canSubmit, () => {
        const formElement = form.value
        if (!formElement) return
        if (formElement.method !== 'post') return

        formElement.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }))
      })
    }
  }
</script>
